/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Sales
 *
 * 1 = Service
 *
 * 2 = Parts
 *
 * 3 = Other
 */
export enum FAQCategories {
  Sales = 0,
  Service = 1,
  Parts = 2,
  Other = 3,
}
